<template>
  <div class="row">
    <div class="col-12 col-md-8">
      <div class="modal-text">

        <article class="reason">
          <h3>{{ $t('more_info.what_you_should_know') }}</h3>
          <ul class="list list-unstyled">
            <li v-for="(item, key) in moreInfo.supplier_data.sales_messages" :key="key">
              <span v-if="item.length > 0">
                <i class="icon-check_circle"></i>
                {{ item }}
              </span>
            </li>
          </ul>
        </article>
        <article class="reason">
          <h3>{{ $t('more_info.description_of')}} {{ moreInfo.moreInfo_name }}</h3>
          <p v-html="moreInfo.hotel_info.description"></p>
        </article>
        <ul class="info-list list-unstyled">
          <li>
            <span v-tooltip="{ 
              content: `
                <strong>${$t('airporthotel.results.journey')}:</strong>
                <p>${moreInfo.supplier_data.airport_transfer }</p>
                <strong>${$t('airporthotel.results.charges')}:</strong>
                <p>${ moreInfo.supplier_data.transfer_charges }</p>
              `}">
              <i class="icon-bus"></i>{{ $t('airporthotel.results.transfers') }}
            </span>
          </li>
          <li>
            <span v-tooltip="{ content: moreInfo.supplier_data.parking }">
              <i class="icon-directions_car"></i>{{ $t('airporthotel.results.parking') }}
            </span>
          </li>
          <li>
            <span v-tooltip="{ 
              content: `
                <strong>${$t('airporthotel.results.restaurants')}</strong>
                <p>${moreInfo.supplier_data.restaurant}</p>
                <strong>${$t('airporthotel.results.breakfast')}:</strong>
                <p>${moreInfo.supplier_data.breakfast}</p>
              `}">
            <i class="icon-glass"></i>{{ $t('airporthotel.results.food_drink') }}
            </span>
          </li>
          <li>
            <span v-tooltip="{
              content: `
                <img src='https://maps.googleapis.com/maps/api/staticmap?key=${mapKey}&size=250x250&maptype=roadmap&markers=color:blue%7Clabel:H%7C${moreInfo.hotel_data.latitude},${moreInfo.hotel_data.longitude}&markers=color:white%7Clabel:A%7C${airport.latitude},${airport.longitude }' />
              `}">
              <i class="icon-location"></i>{{ $t('airporthotel.results.map') }}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <hotel-right-col />
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify";
import mixins from "@/mixins";
import { HotelRightCol } from "@/components";

export default {
  name: "HotelOverview",
  mixins: [mixins.validate, mixins.globals, mixins.format], 
  components: { HotelRightCol },
  computed: {
    salesMessages() {
      return Object.values(this.moreInfo.supplier_data.sales_messages).filter(a => a)
    },
    airport: get("results/airport"),
    moreInfo: sync("modals/moreInfo")
  }
};
</script>